var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loading"},[_c('loading',{attrs:{"size":"24px","color":"#ffffff","vertical":""}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }